module.exports = __webpack_public_path__ + "5aebac9e8c3ca3ca068b1f1f46640f64.png";